import { motion } from 'framer-motion';
import FeatureCard from '../FeatureCard';
import { useBreakpoint } from '../../hooks/useBreakpoint';

const FeaturesSection = () => {
  const { isMobile, isTablet } = useBreakpoint();
  const features = [
    {
      title: 'NOISE ENGINE',
      subtitle: 'Feed them static.',
      description: 'We inject mathematical chaos into your footprint. AI sees a ghost.',
    },
    {
      title: 'THE AIRLOCK',
      subtitle: 'The internet, behind glass.',
      description: 'Suspicious links load on our cloud server, not your device. You are safe.',
    },
    {
      title: 'THE INTERCEPTOR',
      subtitle: 'The iron handshake.',
      description: 'We simulate every transaction before you sign. If it\'s a trap, we cut the line.',
    },
  ];

  return (
    <section style={{ padding: '80px 16px' }}>
      <div style={{ maxWidth: 1000, margin: '0 auto' }}>
        <motion.div
          style={{ marginBottom: 40 }}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <p
            className="font-mono"
            style={{
              fontSize: 10,
              color: '#00FF41',
              textTransform: 'uppercase',
              letterSpacing: '0.3em',
              marginBottom: 8,
            }}
          >
            CORE_MODULES
          </p>
          <h2
            style={{
              fontSize: 'clamp(20px, 4vw, 32px)',
              fontWeight: 600,
              letterSpacing: '-0.02em',
            }}
          >
            Built Different.
          </h2>
        </motion.div>
        <div style={{ border: '1px solid rgba(242,242,242,0.2)' }}>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: isMobile
                ? '1fr'
                : isTablet
                ? 'repeat(2, 1fr)'
                : 'repeat(3, 1fr)',
            }}
          >
            {features.map((f, i) => (
              <FeatureCard
                key={f.title}
                {...f}
                index={i}
                isLast={isMobile ? true : isTablet ? i % 2 === 1 : i === 2}
                isMobile={isMobile}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
